<template lang="pug">
  .recover-password-view
    .recover-password-view-container
      .h-100.row.align-items-center
        recover-password.col-sm-12.col-md-4(v-if="token" :token="token")
        recover-password-request.col-sm-12.col-md-4(v-else)
</template>
<script>
import RecoverPassword from '../components/auth/RecoverPassword'
import RecoverPasswordRequest from '../components/auth/RecoverPasswordRequest'

export default {
  components: {
    RecoverPassword,
    RecoverPasswordRequest
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  }
}
</script>

<style lang="scss" scoped>
.recover-password-view{
  padding: 1rem;
  height: 100%;
  background-color:#1C3FAA;
  &-container {
    height: 100%;
  }
}
.recover-password {
   margin: auto;
}
</style>
